module.exports = __webpack_public_path__ + "img/ceramic-surprise.57041852.jpg";